export const computeView = (graphData, visibleNodeIds) => {
  const { nodes, edges } = graphData;
  if (!nodes || nodes.length === 0)
    return { nodes: [], edges: [], placeholders: [] };
  const visibleNodes = [];
  const visibleEdges = [];
  const placeholders = [];
  const nodeMap = {};
  nodes.forEach((n) => {
    if (visibleNodeIds.has(n.id)) {
      visibleNodes.push({ ...n });
      nodeMap[n.id] = n;
    }
  });
  edges.forEach((e) => {
    if (visibleNodeIds.has(e.source) && visibleNodeIds.has(e.target)) {
      visibleEdges.push(e);
    }
  });
  const parents = {};
  const children = {};
  edges.forEach((e) => {
    if (!parents[e.target]) parents[e.target] = [];
    parents[e.target].push(e.source);
    if (!children[e.source]) children[e.source] = [];
    children[e.source].push(e.target);
  });
  visibleNodes.forEach((node) => {
    const nodeId = node.id;
    const allParents = parents[nodeId] || [];
    const hiddenParents = allParents.filter((pid) => !visibleNodeIds.has(pid));
    if (hiddenParents.length > 0) {
      placeholders.push({
        id: `placeholder-left-${nodeId}`,
        type: "left",
        parentNodeId: nodeId,
        hiddenNodeIds: hiddenParents,
        count: hiddenParents.length
      });
    }
    const allChildren = children[nodeId] || [];
    const hiddenChildren = allChildren.filter((cid) => !visibleNodeIds.has(cid));
    if (hiddenChildren.length > 0) {
      placeholders.push({
        id: `placeholder-right-${nodeId}`,
        type: "right",
        parentNodeId: nodeId,
        hiddenNodeIds: hiddenChildren,
        count: hiddenChildren.length
      });
    }
  });
  return { nodes: visibleNodes, edges: visibleEdges, placeholders };
};
export const getInitialVisibleNodes = (focusNodeId, graphData) => {
  const visible = /* @__PURE__ */ new Set([focusNodeId]);
  if (graphData && graphData.edges) {
    graphData.edges.forEach((e) => {
      if (e.source === focusNodeId) visible.add(e.target);
      if (e.target === focusNodeId) visible.add(e.source);
    });
  }
  return visible;
};
export const getVisibleNodesToRemove = (nodeId, direction, visibleNodeIds, graphData, focusNodeId) => {
  const branchToRemove = /* @__PURE__ */ new Set();
  const stack = [];
  const parents = {};
  const children = {};
  graphData.edges.forEach((e) => {
    if (!parents[e.target]) parents[e.target] = [];
    parents[e.target].push(e.source);
    if (!children[e.source]) children[e.source] = [];
    children[e.source].push(e.target);
  });
  const startNeighbors = direction === "left" ? parents[nodeId] || [] : children[nodeId] || [];
  startNeighbors.forEach((id) => {
    if (visibleNodeIds.has(id)) {
      stack.push(id);
    }
  });
  while (stack.length > 0) {
    const curr = stack.pop();
    if (branchToRemove.has(curr)) continue;
    branchToRemove.add(curr);
    const neighbors = direction === "left" ? parents[curr] || [] : children[curr] || [];
    neighbors.forEach((next) => {
      if (visibleNodeIds.has(next)) {
        stack.push(next);
      }
    });
  }
  const potentiallyRemaining = /* @__PURE__ */ new Set([...visibleNodeIds]);
  branchToRemove.forEach((id) => potentiallyRemaining.delete(id));
  const reached = /* @__PURE__ */ new Set([focusNodeId]);
  const reachStack = [focusNodeId];
  while (reachStack.length > 0) {
    const curr = reachStack.pop();
    const neighbors = [...parents[curr] || [], ...children[curr] || []];
    neighbors.forEach((next) => {
      if (potentiallyRemaining.has(next) && !reached.has(next)) {
        reached.add(next);
        reachStack.push(next);
      }
    });
  }
  const toRemove = /* @__PURE__ */ new Set();
  visibleNodeIds.forEach((id) => {
    if (!reached.has(id)) {
      toRemove.add(id);
    }
  });
  return toRemove;
};
export const canCollapse = (nodeId, direction, visibleEdges, focusNodeId) => {
  const hasVisibleParents = visibleEdges.some((e) => e.target === nodeId);
  const hasVisibleChildren = visibleEdges.some((e) => e.source === nodeId);
  const isFocus = nodeId === focusNodeId;
  if (direction === "left") {
    return hasVisibleParents && (hasVisibleChildren || isFocus);
  } else {
    return hasVisibleChildren && (hasVisibleParents || isFocus);
  }
};
